interface BetaUsersEmptyStateProps {
  isFiltered: boolean;
}

// Design: Beta Users Admin — empty states inside the list card.
export function BetaUsersEmptyState({ isFiltered }: BetaUsersEmptyStateProps) {
  return (
    <div className="px-4 py-10 text-center" data-testid="beta-users-empty">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-wolisho-brown/[0.06] text-wolisho-brown/25">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87" />
          <path d="M16 3.13a4 4 0 010 7.75" />
        </svg>
      </div>
      {isFiltered ? (
        <>
          <p className="mb-1 text-sm font-bold text-black/40">No matching users</p>
          <p className="text-[13px] text-black/30">Try a different search term.</p>
        </>
      ) : (
        <>
          <p className="mb-1 text-sm font-bold text-black/40">No beta users yet</p>
          <p className="text-[13px] text-black/30">
            Add email addresses above to grant beta access.
          </p>
        </>
      )}
    </div>
  );
}
